import React, { FC, useEffect, useState } from 'react';
import { NavMenu, IconTextButton, Divider } from '@scope/scope-one-ui/core';
import { COLORS } from '@scope/scope-one-ui/theme';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useSelector } from 'react-redux';
import { creditAnalysis } from 'shared/constants/menuItems';
import { checkAccess } from 'shared/hooks/useAccess/checkAccess';

const useStyles = makeStyles(() => ({
  navbarStyles: {
    backgroundColor: COLORS.background.control,
    display: 'flex',
    alignItems: 'center',
    padding: '0 3.75rem',
  },
}));

const moduleNotFound = { label: '', value: '' };

const Subnavigation: FC = () => {
  const { pathname } = useLocation();
  const classes = useStyles();
  const navigate = useNavigate();
  const auth = useSelector((state: any) => state.auth);

  const modules = creditAnalysis.subnavigation
    .filter((item) => !item.hidden)
    .map((item) => {
      return (
        checkAccess({
          permission: item.permission,
          role: item.role,
          environment: item.environment,
          shopPermissions: item.shopPermissions,
          auth,
        }) && { label: item.label, value: item.to }
      );
    })
    .filter((item) => item);

  const initialModule = modules[0];

  const [currentRoute, setCurrentRoute] = useState(initialModule);

  useEffect(() => {
    const currentModule = pathname.split('/')[1];
    const findModule = modules.find((item) => item.value === `/${currentModule}`);
    setCurrentRoute(findModule || moduleNotFound);
  }, [pathname]);

  const navigateTo = (item) => {
    const absolutePath = item.value.startsWith('https://') || item.value.startsWith('http://');
    const bookmarkedPage = localStorage.getItem('bookmarked-home');
    if (absolutePath) {
      window.location.href =
        item.label === 'Overview'
          ? `${window.location.origin}${
              bookmarkedPage && bookmarkedPage !== '' ? bookmarkedPage : '/page-one'
            }`
          : item.value;  
    } else {
      navigate({ pathname: item.value });
    }
  };

  const navLinks = modules.map((item) => ({
    label: item.label,
    onClick: () => navigateTo(item),
  }));

  return (
    <Box width="100%">
      <Box className={classes.navbarStyles}>
        <Box flex={1}>
          <IconTextButton onClick={() => window.history.back()} icon={<ArrowBack />}>
            Back
          </IconTextButton>
        </Box>
        <NavMenu
          divider={false}
          active={currentRoute.label}
          tabs={navLinks}
          variant="secondary"
          pt={2.25}
          tabsBackground={COLORS.background.control}
        />
        <Box flex={1} />
      </Box>
      <Divider />
    </Box>
  );
};
export default Subnavigation;
